import React, { useContext, useEffect, useState } from 'react';
import { Grid, TextField } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import { useAppSelector } from '../../store/configureStore';
import { ApplicationContext } from '../../context/Contexts';
import { InvoiceResponseDto } from '../../interfaces/Case';
import { OrganizationInfoDto } from '../../interfaces/Organization';

export interface RepairServiceInvoiceViewProps {
  invoice: InvoiceResponseDto;
}

const NumberFormatCustom = (numberProps: any) => {
  const { inputRef, onChange, ...other } = numberProps;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values: any) => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      decimalScale={0}
      isNumericString
    />
  );
};

const NumberFormatCustomDecimal = (numberProps: any) => {
  const { inputRef, onChange, ...other } = numberProps;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values: any) => {
        onChange({
          target: { value: values.value },
          currentTarget: { value: values.value }
        });
      }}
      allowNegative={false}
      thousandSeparator={false}
      decimalScale={2}
    />
  );
};

const RepairServiceInvoiceView = (props: RepairServiceInvoiceViewProps) => {
  const { invoice } = props;
  const { translatorService, organizationService } = useContext(ApplicationContext);
  const appState = useAppSelector((state) => state.app);
  const [issuerOrganization, setIssuerOrganization] = useState<OrganizationInfoDto | null>(null);

  useEffect(() => {
    const loadIssuerOrganization = async () => {
      if (!invoice.issuerOrganizationId) {
        setIssuerOrganization(null);
        return;
      }
      const organizations = await organizationService.GetOrganizationByIds({
        organizationIds: [invoice.issuerOrganizationId]
      });
      setIssuerOrganization(organizations[0] ?? null);
    };
    loadIssuerOrganization();
  }, [invoice.issuerOrganizationId]);

  const currencySuffix = invoice.currency ? ` (${invoice.currency})` : '';

  return (
    <>
      <Grid item xs={12} className="px-2">
        <TextField
          fullWidth
          className="mb-2"
          name="serviceName-view"
          disabled
          value={issuerOrganization?.name ?? ''}
          label={translatorService.Tranlate('REPAIR_SERVICE_INVOICE_SERVICE_NAME', 'Nume service')}
        />
      </Grid>
      <Grid item xs={12} md={6} className="px-2">
        <TextField
          fullWidth
          className="mb-2"
          name="invoiceNumber-view"
          disabled
          value={invoice.invoiceNumber}
          label={translatorService.Tranlate('REPAIR_SERVICE_INVOICE_NUMBER', 'Numar factura')}
        />
      </Grid>
      <Grid item xs={12} md={6} className="px-2">
        <TextField
          fullWidth
          className="mb-2"
          name="invoiceDate-view"
          disabled
          value={
            invoice.invoiceDate
              ? moment(invoice.invoiceDate).format(appState.dateFormat.toUpperCase())
              : ''
          }
          label={translatorService.Tranlate('REPAIR_SERVICE_INVOICE_DATE', 'Data factura')}
        />
      </Grid>
      <Grid item xs={12} md={6} className="px-2">
        <TextField
          fullWidth
          className="mb-2"
          name="amountWithoutVat-view"
          disabled
          value={invoice.amountWithoutVat || ''}
          label={
            translatorService.Tranlate(
              'REPAIR_SERVICE_INVOICE_AMOUNT_WITHOUT_VAT',
              'Valoare fara TVA'
            ) + currencySuffix
          }
          InputProps={{
            inputComponent: NumberFormatCustomDecimal,
            style: { fontWeight: 500 }
          }}
        />
      </Grid>
      <Grid item xs={12} md={6} className="px-2">
        <TextField
          fullWidth
          className="mb-2"
          name="vatValue-view"
          disabled
          value={invoice.vatValue}
          label={translatorService.Tranlate('REPAIR_SERVICE_INVOICE_VAT_PERCENT', 'TVA (%)')}
          InputProps={{
            inputComponent: NumberFormatCustom,
            style: { fontWeight: 500 }
          }}
        />
      </Grid>
      <Grid item xs={12} md={6} className="px-2">
        <TextField
          fullWidth
          className="mb-2"
          name="vatAmount-view"
          disabled
          value={invoice.vatAmount || ''}
          label={
            translatorService.Tranlate('REPAIR_SERVICE_INVOICE_VAT_AMOUNT', 'Valoare TVA') +
            currencySuffix
          }
          InputProps={{
            inputComponent: NumberFormatCustomDecimal,
            style: { fontWeight: 500 }
          }}
        />
      </Grid>
      <Grid item xs={12} md={6} className="px-2">
        <TextField
          fullWidth
          className="mb-2"
          name="totalWithVat-view"
          disabled
          value={invoice.amount || ''}
          label={
            translatorService.Tranlate('REPAIR_SERVICE_INVOICE_TOTAL_WITH_VAT', 'Total cu TVA') +
            currencySuffix
          }
          InputProps={{
            inputComponent: NumberFormatCustomDecimal,
            style: { fontWeight: 500 }
          }}
        />
      </Grid>
    </>
  );
};

export default RepairServiceInvoiceView;
